import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationPreparationNeededPluginService } from './preparation-needed.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';

@Component({
    selector: 'installation-preparation-needed-edit',
    templateUrl: './preparation-needed-edit.component.html',
    standalone: false
})
export class InstallationPreparationNeededEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  preparations: any[];

  @ViewChild('preparationsModal', { static: true }) preparationsModal: ModalComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationPreparationNeededPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updatePreparation(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['preparation'].markAsTouched();
  }

  public openPreparationsSelector() {
    this.openSelector(this.preparationsModal, this.preparations, this.editForm.controls.preparation.value);
  }

  public selectPreparationsMenu(item: any) {
    const selectedIndex = this.editForm.controls.preparation.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.preparation.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.preparations = this.pluginService.getPreparations();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Label ?? ''),
      preparation: new UntypedFormControl(this.plugin.config.Preparation ? this.plugin.config.Preparation : '')
    });
  }
}
